import { render, staticRenderFns } from "./fund-providen.vue?vue&type=template&id=79600a8e&scoped=true&"
import script from "./fund-providen.vue?vue&type=script&lang=js&"
export * from "./fund-providen.vue?vue&type=script&lang=js&"
import style0 from "./fund-providen.vue?vue&type=style&index=0&id=79600a8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79600a8e",
  null
  
)

export default component.exports